import { get, post, put } from "../api.services";
import {
    ConditionAssignmentStrategy,
    ExperimentalUnit,
    PlateLayout,
    RandomizationType,
    SavedObject,
} from "@/services/commonModels";
import _ from "lodash";

export type ExperimentDesignConfig = {
    experimentId?: number | null;
    experimentGroupId?: string | null;
    containerTypeRegistryEntryId: string;
    numberOfReplicates: number;
    rowColumnLayout: PlateLayout;
    randomizationType: RandomizationType;
    experimentalUnit: ExperimentalUnit;
    conditionAssignmentStrategy: ConditionAssignmentStrategy | null;
};

export type SavedExperimentDesignConfig = ExperimentDesignConfig &
    SavedObject<string> & {
        experimentId: number | null;
        experimentGroupId: number | null;
    };

export type SavedExperimentDesignConfigWithOptions = {
    experimentDesignConfig: SavedExperimentDesignConfig | null;
    experimentalUnitOptionsFromSchema: {
        title: string;
        value: ExperimentalUnit;
    }[];
};

export type ExperimentalUnitOption = {
    title: string;
    value: ExperimentalUnit;
};

export const experimentDesignConfigsAPI = {
    fetchForExperimentGroupId: async (
        experimentGroupId: string
    ): Promise<SavedExperimentDesignConfigWithOptions> => {
        return get(`/experimentDesignConfigs/experimentGroup/${experimentGroupId}`);
    },
    fetchForExperimentCode: async (
        experimentCode: string
    ): Promise<SavedExperimentDesignConfigWithOptions> => {
        return get(`/experimentDesignConfigs/experiment/${experimentCode}`);
    },
    createExperimentDesignConfigForExperimentGroup: async (
        experimentGroupId: string,
        experimentDesignConfig: ExperimentDesignConfig
    ): Promise<SavedExperimentDesignConfig> => {
        return post(
            `/experimentDesignConfigs/experimentGroup/${experimentGroupId}`,
            experimentDesignConfig
        );
    },
    createExperimentDesignConfigForExperiment: async (
        experimentCode: string,
        experimentDesignConfig: ExperimentDesignConfig
    ): Promise<SavedExperimentDesignConfig> => {
        return post(
            `/experimentDesignConfigs/experiment/${experimentCode}`,
            experimentDesignConfig
        );
    },
    updateExperimentDesignConfigForExperimentGroup: async (
        experimentGroupId: string,
        id: string,
        experimentDesignConfig: ExperimentDesignConfig
    ): Promise<SavedExperimentDesignConfig> => {
        return put(
            `/experimentDesignConfigs/experimentGroup/${experimentGroupId}/${id}`,
            experimentDesignConfig
        );
    },
    updateExperimentDesignConfigForExperiment: async (
        experimentCode: string,
        id: string,
        experimentDesignConfig: ExperimentDesignConfig
    ): Promise<SavedExperimentDesignConfig> => {
        return put(
            `/experimentDesignConfigs/experiment/${experimentCode}/${id}`,
            experimentDesignConfig
        );
    },
};

export function isExperimentGroupLevelDesignConfig(
    experimentDesignConfig: ExperimentDesignConfig
): boolean {
    return (
        _.isNil(experimentDesignConfig.experimentId) &&
        !_.isNil(experimentDesignConfig.experimentGroupId)
    );
}
